export const GET_CLIENT_BUILD = "GET_CLIENT_BUILD";
export const SET_CLIENT_BUILD = "SET_CLIENT_BUILD";
export const GET_API_SERVER_BUILD = "GET_API_SERVER_BUILD";
export const SET_API_SERVER_BUILD = "SET_API_SERVER_BUILD";
export const GET_AUTH_SERVER_BUILD = "GET_AUTH_SERVER_BUILD";
export const SET_AUTH_SERVER_BUILD = "SET|_AUTH_SERVER_BUILD";
export const GET_WALLET_SERVER_BUILD = "GET_WALLET_SERVER_BUILD";
export const SET_WALLET_SERVER_BUILD = "SET_WALLET_SERVER_BUILD";